import lod_ from "lodash";
import { Badge, Icon, IconButton, Menu, MenuItem, Tooltip } from "@mui/material";
import MDBox from "components/Basics/MDBox";
import MDButton from "components/Basics/MDButton";
import { useEffect, useState } from "react";
import { queryDictionary } from "helpers/dictionary";
import { useDispatch } from "react-redux";
import FiltersDialog from "./FiltersDialog";
import { t } from "i18next";
import ResourceActions from "redux-react/actions/resourceActions";
import { display } from "redux-react/reducers/snackBarReducer";

const iconsStyle = ({ palette: { dark } }) => ({
	color: () => dark.main
});

export const ALLOWED_ACTION_TYPE = [
	"custom",
	"action",
	"visualization",
	"actionFront",
	null,
	undefined,
	""
];

export const ALLOWED_ACTION_TYPE_BUTTON = ["action", "actionFront", null, undefined, ""];

/**
 * Resource events menu
 * @param {*} param0
 * @returns {JSX.Element} - Resource events menu
 */
const ResourceEventsMenu = ({
	resource,
	selectedRows,
	setSelectedRows,
	performAction,
	loadCharts = () => {}
}) => {
	const dispatch = useDispatch();
	const [dictionary, setDictionary] = useState({});
	const [anchorElMenu, setAnchorElMenu] = useState(null);
	const [filtersDialog, setFiltersDialog] = useState({ open: false });

	const events = (resource?.events ?? []).filter(
		// Filter events to only include those that are actions or have no type (old format)
		event => ALLOWED_ACTION_TYPE_BUTTON.includes(event.type) || lod_.isNil(event.type)
	);

	const saveFilters = filters => {
		dispatch(
			ResourceActions.updateResourceConfiguration(resource.code, { filters }, () => {
				dispatch(
					display({
						type: "success",
						message: t("SETTINGS.FILTERS.filtersSaved")
					})
				);
				setFiltersDialog({ open: false });
				loadCharts();
			})
		);
	};

	const getDictionary = async code => {
		if (!lod_.isNil(code)) {
			const result = await queryDictionary(dispatch, code);
			setDictionary(result);
		}
	};

	useEffect(() => {
		if (!lod_.isEmpty(resource?.format?.dictionary) && !lod_.isNil(resource?.format?.dictionary)) {
			getDictionary(resource?.format?.dictionary);
		}
	}, [resource]);

	if (lod_.isNil(resource) || lod_.isEmpty(resource) || lod_.isEmpty(dictionary)) {
		return null;
	}

	return (
		<MDBox>
			{/* Menu's buttons */}
			<Badge
				badgeContent={selectedRows.length}
				color="error"
				anchorOrigin={{
					vertical: "top",
					horizontal: "right"
				}}
			>
				<MDButton
					disabled={lod_.isEmpty(events)}
					variant="contained"
					color="dark"
					onClick={e => {
						setAnchorElMenu(e.currentTarget);
					}}
				>
					<Icon>list_alt</Icon>&nbsp;{t("FORMS.RESOURCE.actionResource")}
				</MDButton>
			</Badge>
			{/* Menu */}
			<Menu
				anchorEl={anchorElMenu}
				open={Boolean(anchorElMenu)}
				onClose={() => setAnchorElMenu(null)}
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "center"
				}}
				transformOrigin={{
					vertical: "top",
					horizontal: "center"
				}}
			>
				{/* Actions */}
				{events.map((event, index) => {
					return (
						<MenuItem
							disabled={selectedRows.length < 1}
							key={index}
							onClick={() => {
								setAnchorElMenu(null);
								setSelectedRows([]);
								performAction(event, selectedRows);
							}}
						>
							{event.icon && (
								<>
									<Icon fontSize="medium">{event.icon}</Icon>&nbsp;
								</>
							)}
							{event.description}
						</MenuItem>
					);
				})}
			</Menu>
			{/* Filters */}
			<Tooltip title={t("SETTINGS.FILTERS.addFilters")} placement="top" arrow>
				<IconButton size="medium" onClick={() => setFiltersDialog({ open: true })}>
					<Icon sx={iconsStyle}>filter_alt</Icon>
				</IconButton>
			</Tooltip>
			<FiltersDialog
				filtersDialog={filtersDialog}
				setFiltersDialog={setFiltersDialog}
				dictionary={{ [resource.format?.dictionary]: dictionary }}
				filters={resource.filters ?? []}
				onSave={saveFilters}
			/>
		</MDBox>
	);
};

export default ResourceEventsMenu;
